import { Routes } from '@angular/router';
import { VerifyResetPasswordComponent } from './pages/verify-reset-password/verify-reset-password.component';

export const VERIFY_RESET_PASSWORD_ROUTES: Routes = [
    {
        path: 'verify-reset-password',
        component: VerifyResetPasswordComponent,
    },
];
